document.addEventListener('DOMContentLoaded', function() {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll('[data-bg]'));

    function applyBackgroundImage(element) {
        var bgData = JSON.parse(element.getAttribute('data-bg'));
        if (bgData && bgData.length) {
            var mediaQueries = [];

            function setBackground() {
                for (var i = bgData.length - 1; i >= 0; i--) {
                    var bg = bgData[i];
                    if (bg.screen_width === 'desktop' || (mediaQueries[i] && mediaQueries[i].matches)) {
                        var protocolRelativeUrl = bg.url.replace(/^https?:/, '');
                        
                        // Create a new image to preload
                        const img = new Image();
                        
                        img.onload = function() {
                            // Once image is loaded, set the background and trigger the fade
                            element.style.backgroundImage = `url('${protocolRelativeUrl}')`;
                            // Small delay to ensure the background is set before fading
                            requestAnimationFrame(() => {
                                element.classList.add('loaded');
                            });
                        };
                        
                        img.src = protocolRelativeUrl;
                        break;
                    }
                }
            }

            bgData.forEach(function(bg, index) {
                if (bg.screen_width !== 'desktop') {
                    var mq = window.matchMedia(`(${bg.query_type}: ${bg.screen_width})`);
                    mediaQueries[index] = mq;
                    mq.addListener(setBackground);
                }
            });

            setBackground();
        }
    }

    if ('IntersectionObserver' in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    applyBackgroundImage(entry.target);
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    } else {
        // Fallback for browsers that don't support IntersectionObserver
        lazyBackgrounds.forEach(applyBackgroundImage);
    }
});